import React, { useState } from "react";
import "../css/mediaCard.css";
import { EditMeidaCardIcon, EyeMeidaCardIcon, TrashMeidaCardIcon } from "../../../../../asset-controller-mod/asset-serv/icons/iconExporter";

interface MediaCardActionButtonProps {
  children:   React.ReactNode;
  onClick?:   () => void;
  className?: string;
  ariaLabel?: string;
}

 /* istanbul ignore next */ 
const MediaCardActionButton = ({
  children,
  onClick,
  className ="",
  ariaLabel,
}: MediaCardActionButtonProps) => (
  <button
    className={`scl--cms-components-mediaCard-actionBtn ${className}`.trim()}
    onClick={onClick}
    aria-label={ariaLabel}
    type="button"
  >
    {children}
  </button>
);

// ─── Badge Icons ──────────────────────────────────────────────────────────────

const ActiveBadgeIcon = () => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="13.5" cy="13.5" r="13.5" fill="#D3F2DD" fillOpacity="0.5"/>
    <path d="M13.5 4C8.2655 4 4 8.2655 4 13.5C4 18.7345 8.2655 23 13.5 23C18.7345 23 23 18.7345 23 13.5C23 8.2655 18.7345 4 13.5 4ZM18.041 11.315L12.6545 16.7015C12.5215 16.8345 12.341 16.9105 12.151 16.9105C11.961 16.9105 11.7805 16.8345 11.6475 16.7015L8.959 14.013C8.6835 13.7375 8.6835 13.2815 8.959 13.006C9.2345 12.7305 9.6905 12.7305 9.966 13.006L12.151 15.191L17.034 10.308C17.3095 10.0325 17.7655 10.0325 18.041 10.308C18.3165 10.5835 18.3165 11.03 18.041 11.315Z" fill="#41CC57"/>
  </svg>
);


const DeactiveBadgeIcon = () => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="13.5" cy="13.5" r="13.5" fill="#FFDDDD" fillOpacity="0.5"/>
    <path d="M4 13.5C4 8.2533 8.2533 4 13.5 4C18.7468 4 23 8.2533 23 13.5C23 18.7468 18.7468 23 13.5 23C8.2533 23 4 18.7468 4 13.5Z" fill="#FE566B"/>
    <path d="M10.5469 10.5522L16.4434 16.4488" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.4434 10.5522L10.5469 16.4488" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// ─── Props ────────────────────────────────────────────────────────────────────

export interface MediaCardProps {
  imageSrc?:  string;
  title?:     string;
  size?:      string;
  isActive?:  boolean;
  onView?:    () => void;
  onEdit?:    () => void;
  onDelete?:  () => void;
  className?: string;
}

const MediaCard = ({
  imageSrc  = "https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=600&q=80",
  title     = "Driven your talent.jpg",
  size      = "2.0 MB",
  isActive  = false,
  onView,
  onEdit,
  onDelete,
  className = "",
}: MediaCardProps) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div //NOSONAR
      className={`scl--cms-components-mediaCard ${className}`.trim()}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="scl--cms-components-mediaCard-imageContainer">

        {/* Image */}
        <img
          src={imageSrc}
          alt={title}
          className="scl--cms-components-mediaCard-image"
        />

        {/* Badge — top-left, hover only */}
        <div className={`scl--cms-components-mediaCard-badge${hovered ? " scl--cms-components-mediaCard-badge--visible" : ""}`}>
          {isActive ? <ActiveBadgeIcon /> : <DeactiveBadgeIcon />}
        </div>

        {/* Gradient Mask */}
        <div className={`scl--cms-components-mediaCard-gradientMask${hovered ? " scl--cms-components-mediaCard-gradientMask--visible" : ""}`} />

        {/* Info Row */}
        <div className={`scl--cms-components-mediaCard-infoRow${hovered ? " scl--cms-components-mediaCard-infoRow--visible" : ""}`}>
          <div className="scl--cms-components-mediaCard-text">
            <span className="scl--cms-components-mediaCard-title" title={title}>
              {title}
            </span>
            <span className="scl--cms-components-mediaCard-size">{size}</span>
          </div>
          <div className="scl--cms-components-mediaCard-actions">
            <MediaCardActionButton onClick={onView} ariaLabel="View" className="scl--cms-components-mediaCard-actionBtn--view">
              <EyeMeidaCardIcon />
            </MediaCardActionButton>
            <MediaCardActionButton onClick={onEdit} ariaLabel="Edit" className="scl--cms-components-mediaCard-actionBtn--edit">
              <EditMeidaCardIcon />
            </MediaCardActionButton>
            <div className="scl--cms-components-mediaCard-divider" />
            <MediaCardActionButton onClick={onDelete} ariaLabel="Delete" className="scl--cms-components-mediaCard-actionBtn--delete">
              <TrashMeidaCardIcon />
            </MediaCardActionButton>
          </div>
        </div>

      </div>
    </div>
  );
};

export default MediaCard;